'use client'
import { SOCIAL_LINKS } from '@/config/global-config'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import { keyframes } from '@mui/material/styles'
import { FacebookMessengerIcon } from 'react-share'

/**
 * Component nút chat Facebook Messenger
 * - Fixed position ở góc dưới bên phải
 * - Responsive size cho mobile và desktop
 * - Hiệu ứng hover, pulse, và shadow
 */
export const FacebookMessengerButton = () => {
  // Animation pulse cho icon
  const pulse = keyframes`
    0% {
      box-shadow: 0 0 0 0 rgba(0, 132, 255, 0.7);
    }
    50% {
      box-shadow: 0 0 0 10px rgba(0, 132, 255, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(0, 132, 255, 0);
    }
  `

  return (
    <Tooltip title="Chat với chúng tôi trên Messenger" placement="left" arrow>
      <IconButton
        component="a"
        href={SOCIAL_LINKS.messenger}
        target="_blank"
        size="small"
        rel="noopener noreferrer"
        aria-label="Chat trên Messenger"
        sx={{
          padding: 0,
          borderRadius: '50%',
          bottom: '4.5rem !important',
          boxShadow: '0 4px 12px rgba(0, 132, 255, 0.3)',
          animation: `${pulse} 1.5s infinite`,
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            transform: 'scale(1.15)',
            boxShadow: '0 8px 24px rgba(0, 132, 255, 0.5)',
            animation: `${pulse} 1.5s infinite`,
          },
          '&:active': {
            transform: 'scale(1.05)',
          },
          // Hiệu ứng pulse khi không hover (subtle)
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            borderRadius: '50%',
            animation: `${pulse} 2s infinite`,
          },
        }}
      >
        <FacebookMessengerIcon size={52} round />
      </IconButton>
    </Tooltip>
  )
}
